import React from "react";
import {
  Pressable,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { EtiquetteViewProps } from "../etiquette.types";
import { Ionicons } from "@expo/vector-icons";
import EtiquetteRules from "../../../components/EtiquetteRules";

const CONTENT_MAX_WIDTH = 1796;
const CONTENT_MIN_HEIGHT = 1165;
const CONTENT_SIDE_PADDING = 251;

export default function EtiquetteViewDesktop({
  onContinue,
  onBack,
}: EtiquetteViewProps) {
  return (
    <SafeAreaView style={styles.root}>
      <ScrollView
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.content}>
          <View style={styles.navContainer}>
            <Text style={styles.title}>
              You&#39;re about to enter a safe conversation space
            </Text>
            <Text style={styles.subtitle}>
              Take a moment to review how we care for one another here.
            </Text>
          </View>

          <View style={styles.contentContainer}>
            <EtiquetteRules />
            <View style={styles.actionButtons}>
              <Pressable style={styles.cancelButton} onPress={onBack}>
                <Text style={styles.cancelButtonText}>CANCEL</Text>
              </Pressable>
              <Pressable style={styles.agreeButton} onPress={onContinue}>
                <Text style={styles.agreeButtonText}>AGREE AND JOIN</Text>
              </Pressable>
            </View>
          </View>

          <View style={styles.bottomFooter}>
            <View style={styles.footerSpacer} />
            <Text style={styles.copyright}>© COPYRIGHT KNEXO 2023</Text>
            <View style={styles.feedbackWrapper}>
              <TouchableOpacity style={styles.feedbackButton}>
                <Ionicons name="chatbubble-outline" size={14} color="#f6f7f9" />
                <Text style={styles.feedbackText}>FEEDBACK</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: "#232335",
  },
  scrollContent: {
    flexGrow: 1,
    alignItems: "center",
  },
  content: {
    width: "100%",
    maxWidth: CONTENT_MAX_WIDTH,
    minHeight: CONTENT_MIN_HEIGHT,
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    paddingTop: 24,
    paddingBottom: 16,
    alignSelf: "center",
    backgroundColor: "#232335",
  },
  navContainer: {
    alignItems: "center",
    width: "100%",
    paddingHorizontal: 40,
    paddingVertical: 16,
    height: 102,
  },
  title: {
    fontSize: 36,
    fontWeight: "700",
    lineHeight: 40,
    letterSpacing: -1,
    color: "#f6f7f9",
    textAlign: "center",
  },
  subtitle: {
    fontSize: 16,
    lineHeight: 14,
    marginTop: 16,
    color: "#f6f7f9",
    textAlign: "center",
  },
  contentContainer: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 48,
    paddingHorizontal: CONTENT_SIDE_PADDING,
    gap: 48,
    height: 842,
    backgroundColor: "#232335",
    width: "100%",
  },
  actionButtons: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 24,
    width: 542,
    height: 62,
  },
  cancelButton: {
    width: 259,
    height: 62,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "#52526d",
    backgroundColor: "transparent",
    alignItems: "center",
    justifyContent: "center",
  },
  cancelButtonText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#f6f7f9",
    textTransform: "uppercase",
  },
  agreeButton: {
    width: 259,
    height: 62,
    borderRadius: 16,
    backgroundColor: "#3a6fb1",
    alignItems: "center",
    justifyContent: "center",
  },
  agreeButtonText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#fff",
    textTransform: "uppercase",
  },
  bottomFooter: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 40,
    paddingVertical: 8,
    height: 78,
    backgroundColor: "#232335",
    width: "100%",
    marginTop: 56,
  },
  footerSpacer: {
    flex: 1,
  },
  copyright: {
    fontSize: 11,
    color: "#f6f7f9",
  },
  feedbackWrapper: {
    flex: 1,
    alignItems: "flex-end",
  },
  feedbackButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingVertical: 4,
    paddingHorizontal: 24,
    borderRadius: 100,
    backgroundColor: "#7eadeb",
  },
  feedbackText: {
    fontSize: 11,
    fontWeight: "700",
    color: "#f6f7f9",
  },
});
